import * as React from 'react';
import { Query } from 'react-apollo';
import type { QueryResult } from 'react-apollo';

import type { ReactRenderPropsComponent } from '../../../lib/types';
import GetAdminUserRolesQueryDocument from './graphql/GetAdminUserRoles.graphql';
import type {
  GetAdminUserRolesQuery,
  GetAdminUserRolesQueryVariables,
} from './graphql/__generated__/GetAdminUserRoles';

interface Props {
  searchQuery: string;
  partnerId: string;
  userId: string;
  pageSize: number;
  paginationOffset?: string;
}

export type GetAdminUserRolesQueryResult = QueryResult<GetAdminUserRolesQuery, GetAdminUserRolesQueryVariables>;

const AdminUserRolesProvider: ReactRenderPropsComponent<GetAdminUserRolesQueryResult, Props> = ({
  searchQuery,
  partnerId,
  userId,
  pageSize,
  paginationOffset,
  children,
}) => (
  <Query<GetAdminUserRolesQuery, GetAdminUserRolesQueryVariables>
    query={GetAdminUserRolesQueryDocument}
    context={{ clientName: 'gatewayGql' }}
    fetchPolicy="cache-and-network"
    variables={{ input: { query: searchQuery, partnerId, userId }, first: pageSize, after: paginationOffset }}
  >
    {children}
  </Query>
);

export default AdminUserRolesProvider;
